import CompactForm from "app/core/components/CompactForm"
import { scenarioIdEncode } from "app/utils/scenario_id"
import { UpdateBlockgroupOnScenario } from "app/validations"
import { useMutation } from "@blitzjs/rpc"
import { Routes } from "@blitzjs/next"
import { useRouter } from "next/router"
import { Field } from "formik"
import React, { useState, useContext } from "react"
import { Pencil1Icon } from "@radix-ui/react-icons"
import { BlockgroupOnScenario } from "db"
import updateBlockgroupOnScenario from "app/blockgroup-on-scenarios/mutations/updateBlockgroupOnScenario"

import { CityContext } from "app/features/regional-map/regional-map.state"
export function EditableBlockgroupOnScenarioName({
  blockgroupOnScenario,
}: {
  blockgroupOnScenario: BlockgroupOnScenario
}) {
  const city = useContext(CityContext)!
  const router = useRouter()
  const [renaming, setRenaming] = useState<boolean>(false)
  const [updateBlockgroupOnScenarioMutation] = useMutation(updateBlockgroupOnScenario)

  if (renaming) {
    return (
      <div className="p-3">
        <CompactForm
          initialValues={blockgroupOnScenario}
          schema={UpdateBlockgroupOnScenario}
          submitText="Rename block group"
          onSubmit={async (values) => {
            await updateBlockgroupOnScenarioMutation({
              name: values.name,
              treeEquityScoreTarget: blockgroupOnScenario.treeEquityScoreTarget,
              scenarioId: blockgroupOnScenario.scenarioId,
              blockgroupId: blockgroupOnScenario.blockgroupId,
            })
            router.push(
              Routes.Map({
                id: scenarioIdEncode(blockgroupOnScenario.scenarioId),
                city: city.id,
              })
            )
            setRenaming(false)
          }}
        >
          <Field
            type="text"
            className="h-8 flex-auto rounded-md rounded-r-none border border-r-0 border-gray-300 bg-gray-50 px-2 py-0.5 font-medium text-brand-green-dark"
            name="name"
          />
        </CompactForm>
      </div>
    )
  }

  return (
    <div className="flex items-center gap-x-2">
      <div className="font-medium capitalize text-brand-green">{blockgroupOnScenario.name}</div>
      <button
        className="text-black opacity-30 transition-opacity hover:opacity-100"
        onClick={() => setRenaming(true)}
      >
        <Pencil1Icon />
      </button>

      <span className="text-brand-green">| {blockgroupOnScenario.blockgroupId}</span>
    </div>
  )
}
